import React, { useState, useEffect } from 'react';
import './App.css';
import SummaryView from './components/SummaryView';
import TimePeriodView from './components/TimePeriodView';
import BatchView from './components/BatchView';
import ClientView from './components/ClientView';
import CallsTableView from './components/CallsTableView';

function App() {
  const [viewType, setViewType] = useState('summary');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const API_BASE = process.env.REACT_APP_API_URL || 'https://aicall.appbot.do';

  const renderView = () => {
    switch (viewType) {
      case 'summary':
        return <SummaryView apiBase={API_BASE} loading={loading} setLoading={setLoading} error={error} setError={setError} />;
      case 'time':
        return <TimePeriodView apiBase={API_BASE} loading={loading} setLoading={setLoading} error={error} setError={setError} />;
      case 'batch':
        return <BatchView apiBase={API_BASE} loading={loading} setLoading={setLoading} error={error} setError={setError} />;
      case 'client':
        return <ClientView apiBase={API_BASE} loading={loading} setLoading={setLoading} error={error} setError={setError} />;
      case 'table':
        return <CallsTableView apiBase={API_BASE} loading={loading} setLoading={setLoading} error={error} setError={setError} />;
      default:
        return <SummaryView apiBase={API_BASE} loading={loading} setLoading={setLoading} error={error} setError={setError} />;
    }
  };

  return (
    <div className="App">
      <div className="container">
        <header className="header">
          <h1>📊 AppBot Analytics Dashboard</h1>
          <p>Monitor AI call costs, track performance, and calculate client billing</p>
        </header>

        <div className="controls">
          <div className="control-group">
            <label htmlFor="viewType">View Type</label>
            <select 
              id="viewType" 
              value={viewType} 
              onChange={(e) => setViewType(e.target.value)}
            >
              <option value="summary">Summary</option>
              <option value="time">Time Period</option>
              <option value="batch">By Batch</option>
              <option value="client">By Client</option>
              <option value="table">Calls Table</option>
            </select>
          </div>
        </div>

        {error && (
          <div className="error">
            ⚠️ {error}
          </div>
        )}

        {renderView()}
      </div>
    </div>
  );
}

export default App;
